export const Avatar = {
  baseStyle: {
    container: {
      userSelect: "none",
      color: "white",
      bgColor: "brand",
    },
    color: "white",
    bgColor: "brand",
  },
};
